import { Dialog } from '@headlessui/react';

const Modal = ({ isOpen, onClose, children, title, size = 'md' }) => {
    // Determine modal size
    let sizeClass = 'max-w-2xl';
    if (size === 'sm') sizeClass = 'max-w-md';
    if (size === 'lg') sizeClass = 'max-w-4xl';
    if (size === 'xl') sizeClass = 'max-w-6xl';
    if (size === 'full') sizeClass = 'max-w-7xl';

    return (
        <Dialog open={isOpen} onClose={onClose} className="relative z-50">
            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <Dialog.Panel className={`mx-auto w-[90vw] ${sizeClass} bg-white rounded-xl max-h-[90vh] overflow-y-auto`}>
                    {title && (
                        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                            <Dialog.Title className="text-lg font-medium text-gray-900">
                                {title}
                            </Dialog.Title>
                            <button
                                onClick={onClose}
                                className="text-gray-500 hover:text-gray-700"
                                aria-label="Close"
                            >
                                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    )}
                    <div className={title ? 'p-6' : 'p-6'}>
                        {children}
                    </div>
                    {!title && (
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                            aria-label="Close"
                        >
                            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    )}
                </Dialog.Panel>
            </div>
        </Dialog>
    );
};

export default Modal;